<div class="geofence-blocked-page" role="alert" aria-live="polite">
  <div class="geofence-blocked-content">
    <img
      class="geofence-blocked-logo"
      src="assets/images/healthexam-logo.png"
      alt="Health Exam"
    />

    <p class="geofence-blocked-message">
      We're sorry, Health Exam is not available in your location at this time.
    </p>
  </div>
</div>
